import { PaymentMethodEnum } from './company';

export interface HeadsetActivationCode {
  code: string;
  expireAt: string;
}

interface HeadsetStatus {
  apMacAddress: string;
  battery: number;
  cardState: string;
  firmware: string;
  lastActivity: string;
  alive: boolean;
  charging: boolean;
}

export interface ActiveHeadsetSubscription {
  id: string;
  expireAt: string;
  createdAt: string;
  packageId: string;
  duration: number;
}

export enum WorkingModeEnum {
  reception = 'reception',
  inRoom = 'in_room',
  vipAccess = 'vip_access',
}

interface Room {
  id: string;
  name: string;
  archived: string;
  disabled: string;
  is_test: string;
}

export enum PaymentStatusEnum {
  pending = 'pending',
  succeeded = 'succeeded',
  canceled = 'canceled',
}

export enum PaymentInitiatorEnum {
  headset = 'headset',
  qr_code = 'qr_code',
  desk = 'desk',
}

export interface HeadsetInvoice {
  id: string;
  paymentMethod: PaymentMethodEnum;
  paymentStatus: PaymentStatusEnum;
  paymentInitiator: PaymentInitiatorEnum;
  currency: string;
  packageId: string;
  price: number;
  createAt: string;
  updatedAt: string;
  isTest: boolean;
}

export interface HeadsetSubscription {
  id: string;
  price: number;
  duration: number;
  createAt: string;
  canceledAt: string;
  expiredAt: string;

  paymentMethod: PaymentMethodEnum;
  paymentInitiator: PaymentInitiatorEnum;
}

export interface HeadsetUserEvent {
  id: string;
  eventType: string;
  createAt: string;
  accountId: string;
  email: string;
  action: string;
}

export interface HeadsetEvent {
  id: string;
  eventType: string;
  createAt: string;
  firmware: string;
  metaData: string;
}

export interface HeadsetComment {
  id: string;
  email: string;
  issueDate: string;
  message: string;
  createAt: string;
}

export interface HeadsetMeta {
  log?: string;
}

export interface NewHeadsetComment {
  issueDate: string;
  message: string;
}

export interface HeadsetEventsResponse {
  eventTypes: string[];
  events: HeadsetEvent[];
}

export interface Headset extends HeadsetListItem {
  id: string;
  type: string;
  active: boolean;
  disabled: boolean;
  vipAccess: boolean;
  isTest: boolean;
  hasActiveSession: boolean;
  phyDeviceId: string;
  globalId: string;
  deviceType?: string;
  label: string;
  roomLabel?: string;
  lastPayment: string;
  room?: Room;
  workingMode: WorkingModeEnum;
  status: HeadsetStatus;
  activeSubscriptions: ActiveHeadsetSubscription[];
  paymentMethods: string[];
  lastUsed: string;

  invoices: HeadsetInvoice[];
  subscriptions: HeadsetSubscription[];
  userEvents: HeadsetUserEvent[];

  events: HeadsetEvent[];
  eventTypes: string[];
  comments: HeadsetComment[];
  meta: HeadsetMeta;
  comment: string | null;

  hotelCustomerSession: {
    activatedAt: string;
    startedAt: string;
    expiredAt: string;
  } | null;
}

export interface HeadsetListItem {
  id: string;
  phyDeviceId: string;
  deviceType?: string;
  humanId: number;

  label: string;
  roomLabel?: string;

  vipAccess: boolean;
  isTest: boolean;

  firmware: string;
  workingMode: string;
  hasActiveSession: boolean;
  hasActiveSubscriptions: boolean;

  battery: number;
  cardState?: string;
  charging: boolean;
  alive: boolean;

  lastActivity: string;
  lastPayment: string;
  lastUsed: string;
  activeSubscriptions: ActiveHeadsetSubscription[];
}
